<template>
  <form @submit.prevent="$emit('submit')" class="basic-information mt-lg-0">
    <div class="d-flex flex-lg-row flex-column gap-3">
      <snow-input-file
        v-model="form.picture"
        is-image
        dimensions="256 x 256"
        title="Imagem do produto"
      />
      <div class="col p-0">
        <div class="p-4 bg-2 rounded-16">
          <snow-input
            v-model="form.name"
            class="mb-6"
            label="Nome do produto *"
            :rules="rules.name"
          />
          <snow-input
            v-model="form.description"
            :rows="4"
            type="textarea"
            class="mb-6"
            label="Descrição *"
            :rules="rules.description"
          />
          <snow-select
            v-model="form.category_id"
            class="mt-2"
            id="category"
            label="Categoria do produto para que seus compradores encontrem mais fácil"
            :options="categories"
            :errors="errors.category_id"
            :disabled="!categories.length"
            required
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { maxLength, required } from "@/functions/validation";
import { mapState } from "vuex";

export default {
  props: {
    form: {
      type: Object,
      default: null
    },
    product: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: null
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photo",
      rules: {
        name: [required(), maxLength(64)],
        description: [required(), maxLength(980)]
      }
    };
  },
  mounted() {
    this.$store.dispatch("product/getCategories").then();
  },
  watch: {
    form(val) {
      if (val.category) {
        this.form.category_id = val.category.id;
      }
    }
  },
  computed: {
    ...mapState("product", ["categories"]),
    isValid() {
      return (
        this.form.name &&
        this.form.name.length <= 64 &&
        this.form.description &&
        this.form.description.length <= 980 &&
        this.form.category_id
      );
    }
  }
};
</script>
